import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StarIcon from '@mui/icons-material/Star';
import './MovieCard.css';

const MovieCard = ({ movie, index, variant = 'poster' }) => {
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        delay: index * 0.1,
      },
    },
  };

  if (variant === 'horizontal') {
    return (
      <motion.article 
        className="movie-card movie-card--horizontal"
        variants={cardVariants}
        initial="hidden"
        animate="visible"
        whileHover={{ scale: 1.02 }}
      >
        <Link to={`/movie/${movie.id}`} className="movie-card__link">
          <div className="movie-card__image-wrapper">
            <img 
              src={movie.poster} 
              alt={movie.title}
              className="movie-card__image"
            />
            <div className="movie-card__overlay">
              <button className="movie-card__play-btn">
                <PlayArrowIcon />
              </button>
            </div>
          </div>
          <div className="movie-card__content">
            <h4 className="movie-card__title">{movie.title}</h4>
            <p className="movie-card__meta">
              {movie.year} • {movie.genre}
            </p>
            <p className="movie-card__description">{movie.description}</p>
            {movie.rating && (
              <div className="movie-card__rating">
                <StarIcon fontSize="small" />
                <span>{movie.rating}</span>
              </div>
            )}
          </div>
        </Link>
      </motion.article>
    );
  }

  return (
    <motion.article 
      className="movie-card"
      variants={cardVariants}
      initial="hidden"
      animate="visible"
      whileHover={{ scale: 1.05 }}
      data-aos="fade-up"
      data-aos-delay={index * 50}
    >
      <Link to={`/movie/${movie.id}`} className="movie-card__link">
        <div className="movie-card__poster-wrapper">
          <motion.img 
            src={movie.poster} 
            alt={movie.title}
            className="movie-card__poster"
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.3 }}
          />
          <div className="movie-card__hover-overlay">
            <motion.button 
              className="movie-card__play-btn"
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.95 }}
            >
              <PlayArrowIcon fontSize="large" />
            </motion.button>
          </div>
          {movie.isNew && (
            <span className="movie-card__badge">NEW</span>
          )}
        </div>
        <div className="movie-card__info">
          <h4 className="movie-card__title">{movie.title}</h4>
          <p className="movie-card__year-genre">
            {movie.year} • {movie.genre}
          </p>
        </div>
      </Link>
    </motion.article>
  );
};

export default MovieCard;